const emailValidator = (email: string) => {
  const genericEmailList = ['hello', 'hi', 'marketing', 'info', 'support', 'admin'];

  if (email && genericEmailList.includes(email.split('@')[0].toLowerCase())) {
    return "This email seems like a shared inbox. Sked works best when you don't use shared inboxes and instead invite your team to have their own logins.";
  }
};

export default emailValidator;
